module.exports = __webpack_public_path__ + "images/help/icon-twr55@2x-7bfe57a8cdad18a3246241f52d637e02.png";